<template>
 <div>
  <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
  <div  v-else class="credit-create-page">
    <!--  credit form component -->
    <CreditForm
      :title="title"
      :submitted="submitted"
      :duplicatecode="duplicatecode"
      v-on:onSubmit="onSubmit($event)"
      v-on:FormUpdate="FormUpdate = 1"
      page="create"
    >
      <!-- footer block -->
      <template slot="footer">
        <div class="footer" style="box-shadow:0 0 5px #ccc;">
          <div :class="{'form-action' : true,  'unselectable' : submitted}">
            <b-button
              type="submit"
              variant="primary"
              class="btn-rounded mr-3"
              :disabled="submitted"
            >
              <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
            </b-button>
          </div>
        </div>
      </template>
    </CreditForm>
  </div>
  </div>
</template>

<script>
import CreditForm from "@/components/Form/Credit/CreditForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";
/// back to top for scroll to top of the page

export default {
  name: "CreditCreate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    CreditForm,
    RecordNotFound
  },
  data() {
    return {
      FormUpdate: 0,
      title: "Credit Note",
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(data) {
      this.submitted = true;
      this.$store
        .dispatch("credit/createList", data)
        .then((response) => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
            var saved_data = JSON.parse(data);
            if (saved_data.header_details.crdt_term_changed) {
              this.crdt_settings_details.internal_notes =
                saved_data.header_details.crdt_terms_cndtn;
            }
            if (saved_data.header_details.crdt_desc_changed) {
              this.crdt_settings_details.cus_inv_notes =
                saved_data.header_details.cus_inv_notes;
            }
          if (this.status_code  == 200) {
           
            //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message:response.data.status,
              type: 'success',
              showCloseButton: true
            });
                if(this.$route.query.invoice_id){
               this.$router.push({
              name: "InvoiceView",
              params: {
                  id: this.$route.query.invoice_id
                }
            });
            }
            else{ 
            //  show if invoice successfully created
            this.$router.push({
              name: "CreditView",
              params: {
                  id: this.updated_id
                }
            });
            }
          } else {
            this.duplicatecode = true;
            this.submitted = false;
          }
        })
        .catch(() => {});
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("credit/fetchCreditDetails").then(() => {
          store
      .dispatch("settings/fetchinvoicesettings", {
       stg_menu: "Credit Note",
        stg_name: "crdt_settings_details"
      });
      next();
    });
  },
  updated: function() {},
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.credit.code,
      updated_id: state => state.credit.updated_id,
      list: state => state.credit.Updatelist,
      type: state => state.credit.type,
      message: state => state.credit.message,
      status_code: state => state.credit.status_code, 
      status_message: state => state.credit.status_message, 
      status_type: state => state.credit.status_type ,

    }),
      crdt_settings_details: {
      get() {
        return this.$store.state.permission.crdt_settings_details;
      },
      set(val) {
        this.$store.state.permission.crdt_settings_details = val;
      }
    }
  }
};
</script> 

<style>
</style>
